import type {
  BrandProfitSummaryQuery,
  BrandProfitTableDataQuery,
} from "@src/__generated__/urql-graphql";
import { BrandReportStore } from "@src/components/modules/reports/brand/common/store";
import { BrandProfitModel } from "@src/components/modules/reports/brand/profit/models";
import { action, makeObservable, observable } from "mobx";
import { createContext, useContext } from "react";

export const StoreContext = createContext({} as Store);
export const useStore = () => useContext(StoreContext);

export class Store {
  readonly key = "brandProfit";
  reportStore: BrandReportStore;
  @observable brands: BrandProfitModel[] = [];
  @observable
  summary?: BrandProfitSummaryQuery["brandRevenueSummary"];

  constructor() {
    makeObservable(this);
    this.reportStore = new BrandReportStore(this.key);
  }

  @action setTableData(query: BrandProfitTableDataQuery) {
    this.brands = query.brandRevenue.result.map((i) => new BrandProfitModel(i));
    this.reportStore.setExpenseBudgetCategories(
      query.expenseBudgetCategories ?? [],
    );

    if (query.brandRevenue.paginatorInfo) {
      this.reportStore.pagination.setFromPaginatorInfo(
        query.brandRevenue.paginatorInfo,
      );
    }
  }

  @action setSummary(query: BrandProfitSummaryQuery) {
    this.summary = query.brandRevenueSummary;
  }
}
